@let materialOptions = materialOptions$ | async;
@if (label) {
  <p-floatlabel variant="on" class="w-full">
    <p-select
      class="w-full p-inputwrapper-filled"
      [options]="materialOptions ?? []"
      optionLabel="label"
      optionValue="value"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      appendTo="body"
      [filter]="true"
      filterBy="label"
      [ngModel]="value"
      (ngModelChange)="onMaterialChange($event)"
    ></p-select>
    <label>{{ label }}</label>
  </p-floatlabel>
} @else {
  <p-select
    class="w-full"
    [options]="materialOptions ?? []"
    optionLabel="label"
    optionValue="value"
    [placeholder]="placeholder"
    [disabled]="isDisabled"
    appendTo="body"
    [filter]="true"
    filterBy="label"
    [ngModel]="value"
    (ngModelChange)="onMaterialChange($event)"
  ></p-select>
}
